import { Row } from 'react-bootstrap';
import './SLayout.scss';

import { useAuthState } from '../states/auth.state';

const SLogin = () => {
  const authState = useAuthState()

  if (authState.get().currentUser) {
    return <></>
  }

  return (
    <section className="login-wrapper">
      <Row>
        <div className='container'>
          {/* <Image src={vellfireImg} fluid className="image-fix" /> */}
        </div>
      </Row>
    </section>
  )
}

export default SLogin;
